var zoomIndicator = class extends HTMLElement {
    constructor() {
        super();
        this.currentDate = new Date();
        // Now you can also use this.currentDate anywhere inside the class.
    }
    connectedCallback() {
        this.showZoomIndicator();
        this.bindDoubleClick();

    }
    bindDoubleClick() {
        let lastTapTime = 0;

        document.addEventListener('touchstart', function (event) {
            const currentTime = new Date().getTime();
            const timeDiff = currentTime - lastTapTime;

            if (timeDiff < 300 && timeDiff > 0) { // Adjust this to set sensitivity in milliseconds
                document.querySelector('.product__zoom-button').click();
                event.preventDefault(); // Prevent firing of click event
            }

            lastTapTime = currentTime;
        }.bind(this));
    }

    showZoomIndicator() {
        // Get the stored date from local storage
        let storedDate = new Date(localStorage.getItem('zoom-indicator'));

        if (!localStorage.getItem('zoom-indicator') || this.currentDate > storedDate) {
            // If the stored date is null or the current date is greater than the stored date
            // Display the zoom indicator
            let zoomIndicator = document.querySelector('.zoom-indicator');
            zoomIndicator.style.display = 'block';
            // Add 24 hours to the current date
            this.currentDate.setHours(this.currentDate.getHours() + 24);

            // Store the updated date in local storage
            localStorage.setItem('zoom-indicator', this.currentDate);

            // Set a timeout of 5 seconds (5000 milliseconds)
            setTimeout(function () {
                // After 5 seconds, hide the zoom indicator
                zoomIndicator.style.display = 'none';
            }, 5000);
        }
    }
}


window.customElements.define("zoom-indicator", zoomIndicator);// Get the current date
